/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateSocialUploadCompositionsDetailMutationRequest, WebAppCreateSocialUploadCompositionsDetailMutationResponse, WebAppCreateSocialUploadCompositionsDetailPathParams, WebAppCreateSocialUploadCompositionsDetail401, WebAppCreateSocialUploadCompositionsDetail403 } from "../models/WebAppCreateSocialUploadCompositionsDetail";

export function getWebAppCreateSocialUploadCompositionsDetailUrl(id: WebAppCreateSocialUploadCompositionsDetailPathParams["id"]) {
  const res = { method: 'POST', url: `/web-app/v1/compositions/${id}/social-uploads` as const }
  return res
}

/**
 * @summary Start social upload for a video-editor edit (composition context)
 * {@link /web-app/v1/compositions/:id/social-uploads}
 */
export async function webAppCreateSocialUploadCompositionsDetail(id: WebAppCreateSocialUploadCompositionsDetailPathParams["id"], data: WebAppCreateSocialUploadCompositionsDetailMutationRequest, config: Partial<RequestConfig<WebAppCreateSocialUploadCompositionsDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateSocialUploadCompositionsDetail401 | WebAppCreateSocialUploadCompositionsDetail403>, WebAppCreateSocialUploadCompositionsDetailMutationRequest>({ method : "POST", url : getWebAppCreateSocialUploadCompositionsDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}